export default __webpack_public_path__ + "static/media/cover2.9cb6d5e2.jpeg";